import React from 'react';
import DetectionGroupContext from '.';

export default function useDetectionGroups() {
  const context = React.useContext(DetectionGroupContext);
  if (context === null) {
    throw new Error('IllegalStateException: useDetectionGroups must be used within a DetectionBadgeContextProvider');
  }
  return context;
}
